import { render, staticRenderFns } from "./TagViewModal.vue?vue&type=template&id=61356a82&scoped=true&"
import script from "./TagViewModal.vue?vue&type=script&lang=js&"
export * from "./TagViewModal.vue?vue&type=script&lang=js&"
import style0 from "./TagViewModal.vue?vue&type=style&index=0&id=61356a82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61356a82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCol,VDialog,VRow,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
